import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "system-header" }
const _hoisted_3 = { class: "system-title" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "time" }
const _hoisted_6 = { class: "avatar" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["id"]
const _hoisted_9 = {
  key: 0,
  class: "sender"
}
const _hoisted_10 = { class: "message-content" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message", { mine: _ctx.message.user.id === _ctx.user.id }])
  }, [
    (_ctx.message.type === 'system')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "system-message",
          id: `messages-${_ctx.message.id}`
        }, [
          _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "system-icon" }, "📢", -1)),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.message.title || "System Announcement"), 1)
          ]),
          _createElementVNode("div", {
            class: "system-content",
            innerHTML: _ctx.decodeMessage(_ctx.message.message)
          }, null, 8, _hoisted_4),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.timeString), 1)
        ], 8, _hoisted_1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.isPrevMessageUserSame)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.message.user.avatar,
                  alt: "avatar"
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            id: `messages-${_ctx.message.id}`,
            class: "message-body"
          }, [
            (_ctx.isLastMessageFromSameUser && _ctx.user.id !== _ctx.message.user.id)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.message.user.name), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", {
                innerHTML: _ctx.decodeMessage(_ctx.message.message),
                class: _normalizeClass([{
              'message-own': _ctx.user.id === _ctx.message.user.id,
            }, "message-over"])
              }, null, 10, _hoisted_11)
            ]),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.timeString), 1)
          ], 8, _hoisted_8)
        ], 64))
  ], 2))
}